module.exports = __webpack_public_path__ + "/images/vertbaudet-logo.c170ffe.svg";